import { Alert } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'

export const DeductibleErrorAlert = () => {
  const { t } = useTranslation('accountHome', {
    keyPrefix: 'currentDeductibles.error'
  })

  return (
    <Alert variation="warn" heading={t('heading')}>
      {t('instructions')}
    </Alert>
  )
}
